import React from 'react'
import { Text, Stack, InlineLink } from '@primer/react-brand'
import Container from './Container'
import LensMark from './landing/LensMark'
import { CivicLensWordmark } from '../../components/Shared/CivicLensBrand'
import Eyebrow from './landing/Eyebrow'
import { CONTACT_EMAIL, PENDING } from '../landingContent'

const COLUMNS = [
  {
    heading: 'Product',
    links: [
      { href: '#how-it-works', label: 'How it works' },
      { href: '#features', label: 'What you can do' },
      ...(PENDING.roadmap ? [{ href: '#roadmap', label: 'Roadmap' }] : []),
      { href: '#pricing', label: 'Pricing' },
      { href: '#faq', label: 'FAQ' },
    ],
  },
  {
    heading: 'Organisation',
    links: [
      { href: 'https://ati.io/about', label: 'About ATI' },
      { href: 'https://ncoc.org', label: 'National Conference on Citizenship' },
      { href: `mailto:${CONTACT_EMAIL}`, label: 'Contact' },
      // The public status page is on the roadmap (2026 Q3); until it exists
      // the link would be a lie, so it waits on PENDING.statusPage.
      ...(PENDING.statusPage ? [{ href: '/status', label: 'System status' }] : []),
    ],
  },
  {
    heading: 'Legal',
    links: [
      { href: '/privacy', label: 'Privacy Policy' },
      { href: '/terms', label: 'Terms of Service' },
    ],
  },
]

const Footer = () => {
  return (
    <footer
      style={{
        padding: '64px 0 40px',
        borderTop: '1px solid var(--brand-color-border-default)',
        background: 'var(--brand-color-canvas-subtle)',
      }}
    >
      <Container>
        <div className="footer-content" style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 5fr) minmax(0, 7fr)', gap: '48px' }}>
          <div>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '10px' }}>
              <LensMark size={26} />
              <CivicLensWordmark fontSize={20} />
            </div>
            <Text as="p" size="200" variant="muted" style={{ marginTop: '14px', maxWidth: '380px' }}>
              Public-interest social listening, developed by the{' '}
              <InlineLink href="https://ati.io" target="_blank" rel="noopener noreferrer">
                Algorithmic Transparency Institute
              </InlineLink>{' '}
              at the National Conference on Citizenship, a congressionally chartered nonprofit.
            </Text>
          </div>

          <div className="footer-links" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', gap: '32px' }}>
            {COLUMNS.map(({ heading, links }) => (
              <div key={heading}>
                <Eyebrow tone="muted" as="h2">{heading}</Eyebrow>
                <Stack direction="vertical" gap="condensed" padding="none" style={{ marginTop: '14px' }}>
                  {links.map(({ href, label }) => (
                    <InlineLink key={href} href={href} style={{ color: 'var(--brand-color-text-default)' }}>
                      <Text size="200">{label}</Text>
                    </InlineLink>
                  ))}
                </Stack>
              </div>
            ))}
          </div>
        </div>

        <div
          style={{
            marginTop: '48px',
            paddingTop: '20px',
            borderTop: '1px solid var(--brand-color-border-muted)',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            gap: '12px',
          }}
        >
          <Text size="100" variant="muted">
            © {new Date().getFullYear()} National Conference on Citizenship. All rights reserved.
          </Text>
          <Text size="100" variant="muted">
            Supported by membership fees and philanthropic funding — not advertising or data resale.
          </Text>
        </div>
      </Container>
    </footer>
  )
}

export default Footer
